module.exports = __webpack_public_path__ + "img/KatanXadimi.a7c6a4a2.jpg";